 <template>
   <div class="lesson">
      <v-header></v-header>
      <div class="flex">
        <!-- <nav-bar></nav-bar> -->
        <div class="flex-1  flex">
          <div class="flex-1  bg-0 video-wrap ">
            <div class="prism-player" id="player-con"></div>
            <!-- <video  class="w-full h-full" controls :src="videoUrl"></video> -->
          </div>
          <div style="width:300px;background:#484f5a">
              <el-menu 
                :default-active="currTab" 
                mode="horizontal" 
                @select="key => currTab = key" 
                class="right-tab mb-10">
                <el-menu-item index="我的课程">我的课程</el-menu-item>
                <el-menu-item index="成绩单">成绩单</el-menu-item>
                <el-menu-item index="证书">证书</el-menu-item>
              </el-menu>
              <el-table
                :default-expand-all="true"
                class="lesson-table"
                v-show="currTab === '我的课程'"
                :height="`${$windowHeight() - 135}px`"
                :row-style="{'background': '#f5f5f5'}"
                :show-header="false" :data="lessonList">
                <el-table-column width="30" type="expand">
                  <template slot-scope="scope">
                    <div>
                      <li :class="`fs-14 c-c pt-10 pb-10 ml-20 flex c-pointer mr-15 ${item.videoId === activeClazz.videoId ? 'vi-color' : ''}`" 
                        @click="selectClazz(item,scope.$index,scope.row.subjectId)" 
                        style="flex-shrink:1" 
                        v-for="(item,i) in scope.row.stuSubjectDetailRecord" 
                        :key="item.subjectDetailId">
                        <i class="el-icon-video-play fs-16 mr-10"></i>
                        <span class="flex-1">{{item.subjectDetailName}}</span> 
                        <span v-if="item.watchRecord && item.watchRecord.isOver" class=" fs-12">已完成</span>
                      </li>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column  width="190" prop="subjectName">
            
                </el-table-column>
                <el-table-column >
                  <template slot-scope="scope">
                      <el-button type="text" @click="nav2doExam(scope.row)" v-if="scope.row.isShowAnswer" size="small">进入答题</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                class="score-table"
                :show-header="false"
                v-show="currTab === '成绩单'"
                :data="reportList"
                :height="`${$windowHeight() - 135}px`">
                <el-table-column width="30" type="expand">
                  <template slot-scope="scope">
                    <el-descriptions class="mlr-40" :column="1">
                      <el-descriptions-item label="试卷成绩">{{scope.row.totalScore}}</el-descriptions-item>
                      <el-descriptions-item label="答对题数">{{scope.row.trueNumber}}</el-descriptions-item>
                      <el-descriptions-item label="答错题数">{{scope.row.falseNumber}}</el-descriptions-item>
                      <el-descriptions-item label="正确率">{{scope.row.correctRate * 100}}%</el-descriptions-item>
                      <el-descriptions-item label="答题用时">{{`${`${scope.row.sumExamSecond / 60}`.split('.')[0]} 分 ${scope.row.sumExamSecond % 60} 秒`}}</el-descriptions-item>
                      <el-descriptions-item label="创建时间">{{scope.row.examStartTime}}</el-descriptions-item>
                    </el-descriptions>
                  </template>
                </el-table-column>
                <el-table-column prop="examName"></el-table-column>
              </el-table>
              <el-table 
                :show-header="false"
                v-show="currTab === '证书'"
                :data="certList"
                class="cert-table"
                :height="`${$windowHeight() - 135}px`">
                <el-table-column prop="subjectName"></el-table-column>
                <el-table-column width="70">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="readCert(scope.row)">查阅</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="examState" :title="`考试科目：${examSubject.subjectName}`" :fullscreen="true">
        <exam @examEnd="onExamEnd" :state="examState" :subject-id="examSubject.subjectId"></exam>
      </el-dialog>
      <el-dialog :visible.sync="certShow" top="5vh" width="700px" :title="`证书-${certInfo.subjectName}`">
        <img class="d-b" style="width:100%" :src="certInfo.certificateUrl" alt="">
        <div class="ta-c">
          <a class="d-ib c-f pd-10 plr-15" style="background: #13c29f; border-radius:3px " :href="certInfo.certificateUrl" download >下载证书</a>
        </div>
      </el-dialog>
      <el-dialog top="5vh" :close-on-click-modal="false" :close-on-press-escape="false"	:show-close="false" :visible.sync="noticeState" width="80%" title="公告">
        <img style="width:100%" src="https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/miniStudyPlatform/notice.jpg" alt="">
        <div class="ta-c mt-10">
          <el-button @click="closeNotice" :disabled="noticeCountdown !== 0" type="primary">已阅读<span v-if="noticeCountdown">({{noticeCountdown}})</span> </el-button>
        </div>
      </el-dialog>
   </div>
 </template>

 <script>
 import {
   Req_GetMyLessonList,
   Req_GetLessonDetail,
   Req_GetVideoUrl,
   Req_SaveCollect,
   Req_UpdateClazzRecord,
   Req_CreateRandomTimes,
   Req_SaveViewTime,
   Req_CheckShowAnswer,
   Req_GetCertList,
   Req_CheckTimeValidity
 } from '@/ajax/lesson'
 import {
   Req_GetReportList
 } from '@/ajax/exam'
 import Exam from '@/components/Exam/Exam'
 const skinLayout = [
  {
    "name": "bigPlayButton",
    "align": "blabs",
    "x": 30,
    "y": 80
  },
  {
    "name": "H5Loading",
    "align": "cc"
  },
  {
    "name": "errorDisplay",
    "align": "tlabs",
    "x": 0,
    "y": 0
  },
  {
    "name": "infoDisplay"
  },
  {
    "name": "tooltip",
    "align": "blabs",
    "x": 0,
    "y": 56
  },
  {
    "name": "thumbnail"
  },
  {
    "name": "controlBar",
    "align": "blabs",
    "x": 0,
    "y": 0,
    "children": [
      {
        "name": "playButton",
        "align": "tl",
        "x": 15,
        "y": 12
      },
      {
        "name": "timeDisplay",
        "align": "tl",
        "x": 10,
        "y": 7
      },
      {
        "name": "subtitle",
        "align": "tr",
        "x": 15,
        "y": 12
      },

      {
        "name": "volume",
        "align": "tr",
        "x": 5,
        "y": 10
      }
    ]
  }
]
 export default {
   data() {
    return  {
      noticeCountdown: 5,
      noticeState: false,
      certShow: false,
      certInfo: {},
      activeLessonIndex: null,
      lessonList: [],
      lessonParams: {},
      videoUrl: '',
      player: null,
      activeClazz: {},
      currTab: '我的课程',
      reportList: [],
      examState: false,
      examSubject: {},
      videoPrevTime: 0,
      timeUpdateFlag: true,
      videoDuration: 0,
      timeStep: 0,
      playedVideoMap: {},
      activeTab: '1',
      certList: [],
      timeValidityMap: {}
    }
  },
   created() {
    // if(!localStorage.getItem('notice20221014')) {
    //   this.noticeState = true
    //   let noticeTimer = setInterval(() => {
    //     this.noticeCountdown --
    //     if(this.noticeCountdown === 0) {
    //       clearInterval(noticeTimer)
    //     }
    //   },1000)
    // }
    
    this.getLessonList()
    this.getReportList()
    this.getCertList()
   },
   methods: {
    closeNotice() {
      localStorage.setItem('notice20221014',1)
      this.noticeState = false
    },
    readCert(row) {
      console.log(row)
      this.certInfo = row
      this.certShow = true
    },
    getCertList() {
      Req_GetCertList().then(res => {
        this.certList = res
      }).catch(err => this.$catchErr(err))
    },
    onExamEnd() {
      this.examState = false
      this.getLessonList()
      this.getReportList()
    },
    nav2doExam(row) {
      this.examSubject = row
      this.examState = true
    },
    getReportList() {
      Req_GetReportList().then(res => {
        this.reportList = res
      }).catch(err => this.$catchErr(err))
    },
    getLessonList() {
      Req_GetMyLessonList().then(res => {
        this.lessonList = res.data
        this.lessonParams = res
      //  let record = null
      //  if(this.lessonList[0]) {
      //    record = this.lessonList[0].stuSubjectDetailRecord
      //  }
      //  if(record && record[0]) {
      //    const clazz = record[0]
      //    this.selectClazz( clazz)
      //  }
        
      }).catch(err => this.$catchErr(err))
    },
    updateViewTime() {
      this.timeStep += 1
      if(this.timeStep === 4) {
        this.timeStep = 0
        this.activeClazz.userViewTime = Number(this.activeClazz.userViewTime) + 1
        if(this.activeClazz.userViewTime >= this.activeClazz.limitViewTime) {
            this.player.pause()
            this.$alert('该视频已超过可播放时长，若想续播，请联系客服')
        }
        if(this.activeClazz.userViewTime % 20 === 0) {
          Req_SaveViewTime({
            stuUserViewTimes:[{
              subjectDetailId: this.activeClazz.subjectDetailId,
              viewedTime: this.activeClazz.userViewTime
            }]
          })
          this.updateClazzRecord().then(() => this.checkShowAnswer())
        }
        if(this.videoDuration - this.activeClazz.watchRecord.progress < 5 && !this.activeClazz.watchRecord.isOver) {
          this.updateClazzRecord().then(() => this.checkShowAnswer())
        }
      }
    },
    saveViewTime() {
      const stuUserViewTimes = []
      for(let key in this.playedVideoMap) {
        stuUserViewTimes.push({
          subjectDetailId: this.playedVideoMap[key].subjectDetailId,
          viewedTime:this.playedVideoMap[key].userViewTime
        })
      }
      Req_SaveViewTime({
          stuUserViewTimes
      }).catch(err => this.$catchErr(err))
    },
    timeUpdateEvent(e) {
      this.updateViewTime()
      this.collectQuestion() 
      this.checkVideoIsJumped()
    },
    checkVideoIsJumped() {
      if(!this.activeClazz.watchRecord.isOver) {
        this.activeClazz.watchRecord.progress = Math.floor(this.player.getCurrentTime())
      }  
    },
    collectQuestion() {
      const timeMap = {}
      const collectTimes = this.activeClazz.collectTimes
      if (!collectTimes) return
      collectTimes.forEach((item,index) => {
        const min = Number(item.split(':')[0])
        const sec = Number(item.split(':')[1])
        timeMap[min*60 +  sec] = index + 1
      });
      const time = Math.floor(this.player.getCurrentTime())
      if(timeMap[time]) {
        const i = timeMap[time] - 1
        collectTimes.splice(i,1)
        this.player.pause()
   
        this.$confirm('收集题目','', {
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {
          return Req_SaveCollect({
            subjectDetailId: this.activeClazz.subjectDetailId,
            timePeriod: `${Math.floor(time / 60)}:${time % 60}`
          })
        }).then(res => {
          if(this.activeClazz.collectNumber) {
            this.activeClazz.collectNumber -= 1
          }
          
          setTimeout(() => {
            this.player.play()
          },100)
        }).catch(err => this.$catchErr(err))
      }

    },
    updateClazzRecord() {
      if(!this.player) return
      const currTime = this.player.getCurrentTime()
      const watchRecord = this.activeClazz.watchRecord
      console.log(currTime,watchRecord.progress)
      if(currTime <= watchRecord.progress) return
      return this.sendRecordRequest(currTime,this.videoDuration - watchRecord.progress < 5 ? 1 : 0)
    },
    sendRecordRequest(progress,isOver) {
      return Req_UpdateClazzRecord({
        subjectDetailId: this.activeClazz.subjectDetailId,
        watchRecord: {
          progress,
          isOver
        }
      }).then(() => {
        this.activeClazz.watchRecord.isOver = isOver
        return Promise.resolve()
      }).catch(err => this.$catchErr(err))
    },
    onVideoEnded() {
      if(!this.activeClazz.watchRecord) {
        this.activeClazz.watchRecord = {}
      }
      Req_SaveViewTime({
        stuUserViewTimes:[{
          subjectDetailId: this.activeClazz.subjectDetailId,
          viewedTime: this.activeClazz.userViewTime
        }]
      })
      if(!this.activeClazz.watchRecord.isOver) {
        this.updateClazzRecord().then(() => this.checkShowAnswer())
      }
    },
    checkShowAnswer() {
      Req_CheckShowAnswer({
         subjectId: this.lessonList[this.activeLessonIndex].subjectId
      }).then(res => {
        this.lessonList[this.activeLessonIndex].isShowAnswer = res.isShowAnswer
        console.log(this.lessonList[this.activeLessonIndex])
      }).catch(err => this.$catchErr(err))
    },
    makeCollectTime() {
      let number = this.activeClazz.collectNumber
      const collectTimes = []
      const timeMap = {}
      while(number) {

          const t = Math.floor(Math.random() * this.videoDuration)
          const time =  `${Math.floor(t / 60)}:${t % 60}`
          if(!timeMap[time]) {
              collectTimes.push(time)
              timeMap[time] = true
              number -= 1
          }
      }
      return collectTimes
    },
    selectClazz(clazz,l_index,subjectId){
      if(clazz.subjectDetailId === this.activeClazz.subjectDetailId) return
      let promise = null
      if(this.timeValidityMap[subjectId] === undefined) {
        console.log(subjectId)
        promise = Req_CheckTimeValidity({subjectId}).then(() => {
          this.timeValidityMap[subjectId] = 1
          return Promise.resolve()
        }).catch(err => {
          this.timeValidityMap[subjectId] = 0
          this.timeValidityMsg = err.message
          this.$message(this.timeValidityMsg)
          return Promise.reject()
        })
      }else if(this.timeValidityMap[subjectId]) {
        promise = Promise.resolve()
      } else {
        promise = Promise.reject()
        this.$message(this.timeValidityMsg)
      }
      promise.then(() => {
        this.player && this.player.pause()
        setTimeout(() => {
          this.activeClazz = clazz
          this.activeLessonIndex = l_index
          let collectTimes = []
          this.getVideo().then(duration => {
            if(this.activeClazz.watchRecord && this.activeClazz.watchRecord.progress > Number(duration) && !this.activeClazz.watchRecord.isOver) {

              this.sendRecordRequest(this.activeClazz.watchRecord.progress, 1).then(() => this.checkShowAnswer())
            }
            if(this.activeClazz.collectType === 10 && this.activeClazz.collectNumber && this.activeClazz.collectTimes.length === 0) {
              collectTimes = this.makeCollectTime()
              return Req_CreateRandomTimes({
                collectTimes,
                subjectDetailId: this.activeClazz.subjectDetailId
              })
            } else {
              this.player.seek(this.activeClazz.watchRecord.progress)
              return Promise.reject()
            }
          }).then(res => {
            this.activeClazz.collectTimes = collectTimes
          }).catch(err => this.$catchErr(err))
        },500)
      })
    },
    videoOnPlay() {
      this.playedVideoMap[this.activeClazz.subjectDetailId] = this.activeClazz
    },
    getVideo() {
      return Req_GetVideoUrl({
        videoId: this.activeClazz.videoId
      }).then(res => {
        this.videoDuration = res.videoDuration
        if(this.player) {
          this.player.dispose()
        }
        const params = {
          "id": "player-con",
          "source": res.videoUrl,
          "width": "100%",
          "height": `${this.$windowHeight() - 105}px`,
          "autoplay": true,
          "isLive": false,
          "rePlay": false,
          "playsinline": true,
          "preload": true,
          "controlBarVisibility": "hover",
          "useH5Prism": true,
        }
        if(!this.activeClazz.watchRecord.isOver) {
          params.skinLayout = skinLayout
        }
        new Aliplayer(params,  player => {
            this.player = player
            this.timeStep = 0
            this.player.on('timeupdate', this.timeUpdateEvent)
            this.player.on('pause', this.updateClazzRecord)
            this.player.on('ended', this.onVideoEnded)
            this.player.on('play', this.videoOnPlay)
          }
        )
        return Promise.resolve(res.videoDuration)
      }).catch(err => this.$catchErr(err))
    }
   },
   watch: {
     examState(nv) {
       nv && this.player && this.player.pause()
     }
   },
   components: {
     Exam
   },
   beforeDestroy() {
    this.updateClazzRecord()
    this.saveViewTime()
   }
 }
 </script>

<style lang="less">
.lesson {
   .video-wrap {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.5);
  }
  .right-tab {
    background: #484f5a;
    display: flex;
  }
  .right-tab .el-menu-item {
    color: #fff  !important;
    flex: 1;
    text-align: center;
    background: #484f5a !important;
  }
  .right-tab .el-menu-item:hover {
    color: #fff !important
  }

  .right-tab .el-menu-item.is-active {
    color: #13c29f  !important;
    border-bottom: 2px solid #13c29f
  }
  .lesson-table,.score-table,.cert-table {
    background: #484f5a;
    .el-table__row,tr {
        background: #484f5a !important;
    }
    .el-table__cell,.el-descriptions-row,.el-table__expanded-cell {
      background: #484f5a !important;
      color:#fff !important
    }
    .el-table__expand-icon {
      color: #fff !important
    }
    td.el-table__cell, th.el-table__cell.is-leaf {
      border-bottom: 1px solid #919191
    }
  }
  
  .el-menu.el-menu--horizontal {
    border: 0 !important;
  }
 
  .el-descriptions-item__label {
    flex:1
  }
  .el-descriptions-item__content {
    flex:none;
    text-align: right;
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/Lesson.vue